/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { isArrayNotEmpty } from "cms/utils/empty-exists";
import React from "react";
import { ContactCardItem } from "./contact-card-item";

const ContactCardComponent = (props) => {
    const component = props?.component;
    const cardList = component?.contact_list ?? [];
    const title = component?.title ?? "";
    const subtitle = component?.subtitle ?? "";

    return (
        <div className="contact-card-component">
            {title && <h2>{title}</h2>}
            {subtitle && <p>{subtitle}</p>}
            {isArrayNotEmpty(cardList) && (
                <div className="contact-card-container">
                    {cardList.map((item, index) => (
                        <ContactCardItem
                            key={`contact-card-${index}`}
                            item={item}
                        />
                    ))}
                </div>
            )

            }
        </div>
    );
};

ContactCardComponent.displayName = "ContactCardComponent";
export { ContactCardComponent };
